import { ITypedReduxAction } from '../../types/redux/actionType';
import { ICompare } from '../../services/compare';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TCompareType } from '../../types/compareType';

export enum EGetComparisonStatus {
  Initial = 'compare/getComparison/initial',
  Loading = 'compare/getComparison/loading',
  Succeed = 'compare/getComparison/succeed',
  Failed = 'compare/getComparison/failed',
}

interface ISucceedPayload extends ICompare {
  compareType: TCompareType;
}

export type TGetComparisonLoading = ITypedReduxAction<EGetComparisonStatus.Loading, TCompareType>;
export type TGetComparisonSucceed = ITypedReduxAction<EGetComparisonStatus.Succeed, ISucceedPayload>;
export type TGetComparisonFailed = ITypedReduxAction<EGetComparisonStatus.Failed, TCompareType>;

export const getComparisonSucceed = actionGenerator<EGetComparisonStatus.Succeed, ISucceedPayload>(
  EGetComparisonStatus.Succeed,
);
export const getComparisonFailed = actionGenerator<EGetComparisonStatus.Failed, TCompareType>(
  EGetComparisonStatus.Failed,
);
export const getComparisonLoading = actionGenerator<EGetComparisonStatus.Loading, TCompareType>(
  EGetComparisonStatus.Loading,
);

export type TGetComparisonActions = TGetComparisonLoading | TGetComparisonSucceed | TGetComparisonFailed;
